import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-add-edit-center',
  templateUrl: './add-edit-center.component.html',
  styleUrls: ['./add-edit-center.component.css']
})
export class AddEditCenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
